import Button from 'devextreme-react/button';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { signinUrl } from '../../api/auth';
import './LoginPage.css';

type FromLocation = { pathname?: string; search?: string; hash?: string };

function loginReturnPath(state: unknown): string {
  const fromLoc = (state as { from?: FromLocation } | null)?.from;
  return fromLoc?.pathname
    ? `${fromLoc.pathname}${fromLoc.search ?? ''}${fromLoc.hash ?? ''}`
    : '/';
}

export function LoginPage() {
  const location = useLocation();
  const from = loginReturnPath(location.state);

  useEffect(() => {
    window.location.assign(signinUrl(from));
  }, [from]);

  function handleSignIn() {
    window.location.assign(signinUrl(from));
  }

  return (
    <div className="login-root">
      <header className="login-brand-header">
        <div className="login-brand-inner">
          <a className="login-brand-link" href="/" aria-label="Go to home">
            <div className="login-brand-logo-wrap">
              <img
                src="/img/ops-hub-logo.webp"
                alt="HVG Operations Hub logo"
                className="login-brand-logo"
              />
            </div>
            <div className="login-brand-text">
              <h1>HVG Operations Hub</h1>
            </div>
          </a>
        </div>
      </header>

      <main className="login-main">
        <div className="login-section">
          <div className="login-card">
            <h2 className="login-card-title">Sign in</h2>
            <p className="login-card-lead">
              Please sign in with your company Microsoft 365 work account to continue.
            </p>
            <Button
              text="Sign in with Microsoft"
              type="default"
              stylingMode="contained"
              width="100%"
              icon="user"
              onClick={handleSignIn}
            />
          </div>
        </div>
      </main>
    </div>
  );
}
